// Operators the API accepts per action-able device filter key, and the default
// applied when a value is typed without picking one. Mirrors
// DeviceFilterRequest on the API: every action-able key sent WITH data and
// WITHOUT an action is a 422, which the Devices and Live pages surfaced as
// "Trackers could not be loaded" because the dialog had no operator control
// for the text keys and no default for the others. 'like' is only legal for
// serial_num (and FilterHelpers' like arm searches devices.slno whatever the
// key); 'range' needs an array a single field cannot produce, so it is omitted.

const COMPARISON = [
    {abbr: 'eq', description: 'Equal to'},
    {abbr: 'lt', description: 'Less than'},
    {abbr: 'gt', description: 'Greater than'},
    {abbr: 'lte', description: 'At or below'},
    {abbr: 'gte', description: 'At or above'},
];
const DATE = [
    {abbr: 'gt', description: 'After'},
    {abbr: 'lt', description: 'Before'},
    {abbr: 'gte', description: 'On or after'},
    {abbr: 'lte', description: 'On or before'},
];
const VOLTAGE = [
    {abbr: 'lt', description: 'Below'},
    {abbr: 'lte', description: 'At or below'},
    {abbr: 'gt', description: 'Above'},
    {abbr: 'gte', description: 'At or above'},
];

export const ACTION_OPERATORS = {
    serial_num: [{abbr: 'like', description: 'Contains'}, ...COMPARISON],
    imei: COMPARISON,
    iccid: COMPARISON,
    voltage: VOLTAGE,
    voltage1: COMPARISON,
    last_update: DATE,
};

// What a typed value means when no condition was chosen. Serial: substring,
// like the search box. IMEI / ICCID: exact. Voltage: "at or below" (the
// threshold reading). Last seen: "on or after".
export const DEFAULT_ACTION = {
    serial_num: 'like',
    imei: 'eq',
    iccid: 'eq',
    voltage: 'lte',
    voltage1: 'lte',
    last_update: 'gte',
};

export const operatorsFor = (key) => ACTION_OPERATORS[key] ?? COMPARISON;

// Fill the default action on every action-able filter that has a value but
// no condition. Mutates and returns the same object so it can run on the
// reactive form. Never overwrites a chosen action; ignores filters with no
// action property (plain text, selects, geo radius) and empty values, so a
// cleared filter stays fully cleared.
export function fillDefaultActions(filters) {
    if (!filters) return filters;
    for (const [key, filter] of Object.entries(filters)) {
        if (!filter || !Object.prototype.hasOwnProperty.call(filter, 'action')) continue;
        if (filter.data === null || filter.data === undefined || filter.data === '') continue;
        if (filter.action) continue;
        const fallback = DEFAULT_ACTION[key];
        if (fallback) filter.action = fallback;
    }
    return filters;
}
